/**
 * 重置任务服务接口标识符
 */
export const ResetTaskService = Symbol.for('ResetTaskService');

/**
 * 重置任务服务接口
 * @description 定义重置查新任务相关的业务操作
 */
export interface ResetTaskService {
    /**
     * 重置任务
     * @param taskId 任务ID
     * @returns 操作是否成功
     * @description 重置指定的查新任务，包括清理任务状态、重置进度等操作
     */
    resetTask(taskId: string): Promise<boolean>;

    /**
     * 检查任务是否可以重置
     * @param taskId 任务ID
     * @returns 是否可以重置
     * @description 检查任务的当前状态是否允许进行重置操作
     */
    canResetTask(taskId: string): Promise<boolean>;
}
